import classNames from "classnames";
import {MouseEventHandler, PropsWithChildren, ReactNode} from "react";
import {Modal} from "react-bootstrap";

import {Button} from "@/components/button/Button.tsx";

import {ButtonVariant} from "../button/Button.types";

export interface ActionDialogProps extends PropsWithChildren {
  show: boolean;
  title: ReactNode;
  loading?: boolean;
  size?: "sm" | "lg" | "xl";
  scrollable?: boolean;
  onCancel: () => void;
  onConfirm: MouseEventHandler<HTMLButtonElement>;
  onSecondaryAction?: MouseEventHandler<HTMLButtonElement>;
  secondaryBtnText?: string;
  confirmBtnText?: string;
  confirmBtnVariant?: ButtonVariant;
  cancelBtnText?: string;
  hasCancelButton?: boolean;
  hasConfirmButton?: boolean;
  disableConfirmButton?: boolean;
  titleClassName?: string;
  centered?: boolean;
  showBorders?: boolean;
  backdropClassName?: string;
  dialogClassName?: string;
  contentClassName?: string;
  bodyClassName?: string;
}

export const ActionDialog = ({
  show,
  onCancel,
  size,
  scrollable,
  title,
  loading,
  children,
  onConfirm,
  onSecondaryAction,
  secondaryBtnText,
  confirmBtnText,
  confirmBtnVariant,
  cancelBtnText,
  hasCancelButton = true,
  hasConfirmButton = true,
  disableConfirmButton = false,
  titleClassName,
  centered = true,
  showBorders = false,
  backdropClassName,
  dialogClassName,
  contentClassName,
  bodyClassName,
}: ActionDialogProps) => (
  <Modal
    show={show}
    onHide={onCancel}
    size={size}
    scrollable={scrollable}
    centered={centered}
    backdropClassName={backdropClassName}
    dialogClassName={dialogClassName}
    contentClassName={contentClassName}
  >
    <Modal.Header closeButton className={classNames({"border-0": !showBorders})}>
      <Modal.Title className={titleClassName}>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body className={bodyClassName}>{children}</Modal.Body>
    <Modal.Footer className={classNames({"border-0": !showBorders})}>
      {hasCancelButton && (
        <Button disabled={loading} onClick={onCancel} variant={"secondary"} data-bs-dismiss="modal" className="me-2">
          {cancelBtnText || "Cancel"}
        </Button>
      )}
      {secondaryBtnText && (
        <Button disabled={loading} onClick={onSecondaryAction} variant="secondary" className="mx-2">
          {secondaryBtnText}
        </Button>
      )}
      {hasConfirmButton && (
        <Button
          disabled={loading || disableConfirmButton}
          onClick={onConfirm}
          variant={confirmBtnVariant}
          className="ms-2"
        >
          {confirmBtnText || "Confirm"}
        </Button>
      )}
    </Modal.Footer>
  </Modal>
);
